<template>
  <div class="item-container">
    <div class="detail">
      <div class="title">{{ title }}</div>
      <div class="subtitle mb-3">
        <div class="value">
          <i class="fab fa-android" v-if="platform === 'ANDROID'"></i>
          <i class="fab fa-apple" v-else-if="platform === 'iOS'"></i>
          <div v-else>{{ platform }}</div>
          {{ version }}
        </div>
      </div>
      <div class="subtitle">
        <span class="label">สร้างเมื่อ</span>
        <div class="value">{{ createdDate }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { toLocaleTH } from "@/lib/dateTime";
import { DateTime } from "luxon";

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    platform: {
      type: String,
      required: true
    },
    version: {
      type: String,
      required: true
    },
    created_at: {
      type: String,
      required: true
    }
  },
  methods: {
    formatDate(date) {
      const format = "dd MMMM yyyy";

      return toLocaleTH(DateTime.fromISO(date)).toFormat(format);
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page }
      };

      this.$router.replace(route);
    }
  },
  computed: {
    queryParams() {
      return {
        page: parseInt(this.$route.query.page) || 1
      };
    },
    createdDate: function() {
      return this.formatDate(this.created_at);
    }
  },
  watch: {
    async "$route.query"(query) {
      await this.setupData();
    }
  }
};
</script>

<style lang="scss" scoped>
.item-container {
  .detail {
    .title {
      font-size: 1.2rem;
      margin-bottom: 5px;
    }

    .label {
      color: #777;
      font-size: 0.9rem;
    }
    .value {
      font-size: 1rem;
    }
  }
  padding: 20px 0;
  border-bottom: 1px solid #dcdfe6;
}
</style>



// WEBPACK FOOTER //
// src/features/communications/modules/featureIntroduction/components/FeatureIntroductionListItem.vue